module.exports = __webpack_public_path__ + "img/bg_partner.1775439203884.png";